exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n * Nesting a form-group inside a form-group breaks the margins of input fields.\n * We reset the margins in that case but scope it to the KeyValueTable component to avoid affecting others by accident.\n */\n.form-horizontal .form-group .key-value-table-component .form-group {\n    margin-left: 0;\n    margin-right: 0;\n}\n", ""]);

// exports
